var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accout-overview-header" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "page-title" }, [
              _vm._v(" " + _vm._s(_vm.$t("merchant.account_balance")) + " "),
            ]),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "accout-overview-header-content" }, [
        _c("div", { staticClass: "num-container" }, [
          _c(
            "div",
            { staticClass: "txt" },
            [
              _vm._v(_vm._s(_vm.$t("merchantAccount.balance_available")) + " "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c(
                  "div",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { slot: "content" },
                    slot: "content",
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("tips.dashboard_balance_question"))),
                    ]),
                  ]
                ),
                _c(
                  "span",
                  [
                    _c("svg-icon", {
                      staticClass: "icon-question",
                      attrs: { "icon-class": "icon-font-question" },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "num" },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$store.getters.currency) +
                  " " +
                  _vm._s(_vm._f("toDivideWithDot")(_vm.balanceInfo.balance)) +
                  " "
              ),
              _c("el-tooltip", { attrs: { placement: "bottom" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("tips.dashboard_balance_number")) +
                        " " +
                        _vm._s(_vm.$store.getters.currency) +
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.balanceInfo.available_withdraw
                          )
                        )
                    ),
                  ]),
                ]),
                _c(
                  "span",
                  [
                    _c("svg-icon", {
                      staticClass: "icon-warning",
                      attrs: { "icon-class": "icon-font-warning" },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "num-container" }, [
          _c("div", { staticClass: "txt" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.amount_in_transit"))),
          ]),
          _c("div", { staticClass: "num" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(
                  _vm._f("toDivideWithDot")(
                    _vm.balanceInfo.fund_settlement_amount
                  )
                ) +
                " "
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "num-container", staticStyle: { padding: "0" } },
          [
            _c("div", { staticClass: "num-adb-container" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("merchantAccount.amount_adb"))),
              ]),
              _c("div", { staticClass: "num" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$store.getters.currency) +
                    " " +
                    _vm._s(
                      _vm._f("toDivideWithDot")(_vm.balanceInfo.adb_amount)
                    ) +
                    " "
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "num-container" },
          [
            _c(
              "el-button",
              {
                staticStyle: { margin: "7px", width: "90px" },
                attrs: { size: "default", type: "primary", plain: "" },
                on: { click: _vm.onClickRechargeBtn },
              },
              [_vm._v(" " + _vm._s(_vm.$t("merchantAccount.top_up")) + " ")]
            ),
            _vm.showCashOut && _vm.withdrawInfo.withdraw_type === 1
              ? [
                  _vm.shouldDisableWithdraw
                    ? _c(
                        "el-tooltip",
                        { attrs: { placement: "top" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("merchantAccount.cash_out_threshold")
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("toThousandFilter")(
                                      _vm.currentWithdrawThreshold
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.$store.getters.currency)
                              ),
                              _c("br"),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { margin: "7px", width: "103px" },
                              attrs: {
                                size: "default",
                                type: "primary",
                                disabled: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("merchantAccount.cash_out")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-button",
                        {
                          staticStyle: { margin: "7px", width: "103px" },
                          attrs: { size: "default", type: "primary" },
                          on: { click: _vm.onClickWithDrawBtn },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("merchantAccount.cash_out")) +
                              " "
                          ),
                        ]
                      ),
                ]
              : _vm._e(),
            _c(
              "el-button",
              {
                staticClass: "filter-btn-add",
                staticStyle: { margin: "7px", width: "208px" },
                attrs: { size: "default", type: "primary" },
                on: { click: _vm.onClickBalanceDetailTxt },
              },
              [_vm._v(_vm._s(_vm.$t("data.balance_details")))]
            ),
          ],
          2
        ),
      ]),
      _c("WithdrawModal", {
        ref: "withdrawModalRef",
        attrs: {
          withdrawThreshold: _vm.currentWithdrawThreshold,
          "withdraw-fee": _vm.withdrawFee,
          "merchant-info": _vm.merchantInfo,
          "balance-info": _vm.balanceInfo,
        },
        on: { "get-merchant-info": _vm.getMerchantInfo },
      }),
      _c("TransModal", {
        ref: "transModalRef",
        attrs: {
          "merchant-info": _vm.merchantInfo,
          balance: _vm.balanceInfo.balance,
        },
        on: { "get-merchant-info": _vm.getMerchantInfo },
      }),
      _c("RechargeModal", { ref: "rechargeModalRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }